import React from "react";
import PropTypes from "prop-types";
import styles from "../assets/stylesheets/presence-log.scss";
import { guessContentType } from "../utils/media-url-utils";

export default function CustomMessage({ name, action, object, imageUrl, externalUrl, className }) {
  const contentType = guessContentType(imageUrl);
  const isImage = ["image/png", "image/jpg", "image/jpeg"].includes(contentType);

  return (
    <div className={className}>
      <div className={styles.mediaBody}>
        <div>
          {name} {action}
          <b>
            {externalUrl ? (
              <a href={externalUrl} target="_blank" rel="noopener noreferrer">
                {object}
              </a>
            ) : (
              object
            )}
          </b>
        </div>
      </div>
      {imageUrl && externalUrl && isImage && (
        <a href={externalUrl} target="_blank" rel="noopener noreferrer">
          <img src={imageUrl} />
        </a>
      )}
    </div>
  );
}
CustomMessage.propTypes = {
  name: PropTypes.string,
  action: PropTypes.string,
  object: PropTypes.string,
  className: PropTypes.string,
  imageUrl: PropTypes.string,
  externalUrl: PropTypes.string
};
